// Material Dashboard 2 React Base Styles
import colors from 'assets/theme-dark/base/colors';

const {transparent} = colors;

const iconButton = {
  styleOverrides: {
    root: {
      '&:hover': {
        backgroundColor: transparent.main,
      },
    },
  },
};

export default iconButton;
